import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
        fallbackLng: 'ar',
        supportedLngs: ['ar', 'en'], // Supported languages
        detection: {
            order: [
                'cookie',
                'querystring',
                'localStorage',
                'sessionStorage',
                'navigator',
                'htmlTag',
                'path',
                'subdomain',
            ],
            caches: ['cookie'],
            lookupCookie: 'i18nextLng',
            lookupLocalStorage: 'i18nextLng',
            lookupSessionStorage: 'i18nextLng',
            lookupQuerystring: 'lng',
            lookupFromPathIndex: 0,
            lookupFromSubdomainIndex: 0,
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },
        interpolation: {
            escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        },
        react: {
            useSuspense: false,
        },
    });

// Set Arabic as the default language after initialization
i18n.changeLanguage('ar');

export default i18n;
